import { Know } from 'interfaces/Know'
import AppFeaturedStory from './ExperimentElements/AppFeaturedStory'

interface Props {
    isLaunched: boolean
    know?: Know
    isDarkTheme?: boolean
    showGradientKnowPageDesign?: boolean
}

const SEOKnowunityAdvantages = ({ isLaunched, know, isDarkTheme }: Props) => {
    return <AppFeaturedStory referrerScreen="seoKnowPage" isLaunched={isLaunched} know={know} isDarkTheme={isDarkTheme} />
}

export default SEOKnowunityAdvantages
